module.exports = __webpack_public_path__ + "img/file.598c0ff8.svg";